








































import {Component, Prop, Vue} from "vue-property-decorator";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";
import {RenderingStatus} from "@api/enums/WebConferenceSlides/RenderingStatus";
import MediaGridImageIcon from "@share/web-conferences/components/media-library/media-table/MediaGridImageIcon.vue";
import {getBackend} from "@service/router/getters";
import RingLoader from "@share/common/RingLoader.vue";
import MediaGridBinIcon from "@share/web-conferences/components/media-library/media-table/MediaGridBinIcon.vue";
import {Modal} from "@common/Modal";
import i18n from "@service/locale/i18";
import {getImageUrl} from "@common/ImageUrlHelper";
import ImageView from "@share/common/ImageView.vue";

@Component({
    name: "MediaGridRow",
    components: {ImageView, MediaGridBinIcon, RingLoader, MediaGridImageIcon}
})
export default class MediaGridRow extends Vue {
    @Prop({required: true}) file: WebConferencesSlides;
    @Prop({default: ''}) beingChosenId: string;

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    get isConvertingCompleted() {
        return this.file.renderingStatus == RenderingStatus.Completed;
    }

    get isConvertingInProgress() {
        return this.file.renderingStatus == RenderingStatus.Rendering;
    }

    get isConvertingFailed() {
        return this.file.renderingStatus == RenderingStatus.Error;
    }

    //@todo cahnge to getImageUrl
    //temporarely use file link coz locally img lib is not working
    get previewLink() {
        return this.firstSlideFileId ? getImageUrl(this.backend, this.firstSlideFileId, 600) : '';
    }

    get firstSlideFileId() {
        if (this.hasSlides) {
            return this.file.fileIds[0];
        }
        return null;
    }

    get hasSlides() {
        return this.file.fileIds && this.file.fileIds.length > 0;
    }

    get isChooseBtnDisabled() {
        return this.beingChosenId != '';
    }

    get isCurrentBeingChosen() {
        return this.beingChosenId == this.file.id;
    }

    get lang() {
        return this.$store.state.session.language || 'en';
    }

    onChoose() {
        this.$emit('choose', this.file);
    }

    async onDelete() {
        const modal = new Modal({
            title: this.$t('web-conferences.media-library.deleteRowQuestion').toString(),
            buttons: [
                {
                    text: i18n.t('common.yes').toString(),
                    class: 'is-green',
                    returnValue: true
                },
                {
                    text: i18n.t('common.no').toString(),
                    class: 'is-red is-outlined',
                    returnValue: false
                },
            ]
        });

        const modalResult = await modal.showConfirm<boolean>(false);

        if (modalResult) {
            this.$emit('delete');
        }
    }
}
